import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import {
  InputHLPure,
  ButtonHLPure,
  DialogSystemGLPure,
  SubtitlePageHLPure,
} from "../../../pures";
import { useTranslation } from "react-i18next";
import "./user-administration-add-new-user.view.css";
import { profileIconDefault } from "../../../../assets/logos/icons";

const UserAdministrationAddNewUserView = ({
  selectedUser,
  hideShowDetails,
  validators,
  saveNewUser,
  token,
  imgProfileSubtitle,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  showWarningRequesting,
  toggleWarningRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  message,
}) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [errorInEmail, setErrorInEmail] = useState(false);

  const handleEmailInput = (e) => {
    setEmail(e.target.value);
  };

  const handleSave = () => {
    let invalidateEmail = validators.emailValidator(email);
    if (invalidateEmail) {
      setErrorInEmail(true);
    } else {
      setErrorInEmail(false);
      const body = {
        email: email,
      };
      saveNewUser(token, body);
    }
  };

  return (
    <Grid
      item
      lg={12}
      md={12}
      sm={12}
      xs={12}
      className="userAdministrationAddNewUserView-wrapper"
    >
      <>
        <Grid
          item
          lg={12}
          md={12}
          xs={12}
          sm={12}
          className="userAdministrationAddNewUserView-subtitle"
        >
          <SubtitlePageHLPure
            subtitle={t("userAdministrationAddNewUserView.addUser")}
            imgProfile={profileIconDefault}
            profileImg={imgProfileSubtitle}
            tooltipShow={false}
          />
        </Grid>
        <Grid
          container
          className="userAdministrationAddNewUserView-body"
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
        >
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="userAdministrationAddNewUserView-form"
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="userAdministrationAddNewUserView-textAreaHLPure"
            >
              <InputHLPure
                labelInput={t("userAdministrationAddNewUserView.email")}
                valueInput={email}
                handleChangeInput={handleEmailInput}
                typeInput={"text"}
                errorInputText={t(
                  "userAdministrationAddNewUserView.errorEmail"
                )}
                errorInput={errorInEmail}
                inputActive
              />
            </Grid>
          </Grid>
          <Grid
            container
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="userAdministrationAddNewUserView-btnGroup"
          >
            <Grid className="userAdministrationAddNewUserView-spaceBtns">
              <ButtonHLPure
                nameBtn={t("button.return")}
                onClickBtn={hideShowDetails}
                primary={false}
              />
            </Grid>
            <ButtonHLPure primary nameBtn={t("button.save")} onClickBtn={handleSave} />
          </Grid>
        </Grid>
        <DialogSystemGLPure
          showLoadingRequesting={showLoadingRequesting}
          showCompletedRequesting={showCompletedRequesting}
          showErrorRequesting={showErrorRequesting}
          toggleLoadingRequesting={toggleLoadingRequesting}
          toggleCompletedRequesting={toggleCompletedRequesting}
          toggleErrorRequesting={toggleErrorRequesting}
          toggleWarningRequesting={toggleWarningRequesting}
          showWarningRequesting={showWarningRequesting}
          message={message}
        />
      </>{" "}
    </Grid>
  );
};

export default UserAdministrationAddNewUserView;
